module.exports = __webpack_public_path__ + "img/uid-login.5cb43997.png";